function ShopRegistration(){
    var form = document.checkUserAndShopName;
    var $shopRegistrationButton = $('#sendboltdata');
    var $shopRegistrationName = $('#webv');
    var $shopRegistrationEmail = $('#emailv');
    var $shopRegistrationEmailFront = $('#emailvfront');
    var $shopRegistrationPassword = $('#paddwordv');
    var $errorRegistrationEmail = $('#errorEmail');
    var $errorRegistrationName = $('#errorWebcim');
    var $errorRegistrationPassword = $('#errorPassword');

    //legyen autofocus az email-en
    $('#SR-reg').on('shown.bs.modal', function() {
        $(this).find('[autofocus]').focus();
    });

    $(document).ready(function(a) {
        $('.form-group-custom input.form-control').focus(function(){
            $(this).parent().addClass('not-empty');
            $(this).parent().removeClass('has-error');
        }).blur(function(){
                tmpval = $(this).val();
                if(tmpval === '') {
                    $(this).parent().addClass('empty');
                    $(this).parent().removeClass('not-empty');
                } else {
                    $(this).parent().addClass('not-empty');
                    $(this).parent().removeClass('empty');
                }
            });
    });


    $('.copy-email-button #createShopOverlay').click(function () {
        $shopRegistrationEmail.val($shopRegistrationEmailFront.val());
        if($shopRegistrationEmailFront.length > 0) {
            if($shopRegistrationEmail.val().length > 0) {
                $shopRegistrationEmail.parent().addClass('not-empty');
                $shopRegistrationEmail.parent().removeClass('empty');
            }
            else {
                $shopRegistrationEmail.parent().addClass('empty');
                $shopRegistrationEmail.parent().removeClass('not-empty');
            }
        }
    });


    $shopRegistrationButton.click(function (event) {
        event.preventDefault();
        submitValidation();
    });

    $shopRegistrationEmail.focusout(function () {
        if ($shopRegistrationEmail.val() === '') {
            $errorRegistrationEmail.removeClass('notvalidfrontpage');
        } else {
        validEmail();
        }

    });
    $shopRegistrationPassword.focusout(function () {
        if ($shopRegistrationPassword.val() === '') {
            $errorRegistrationPassword.removeClass('notvalidfrontpage');
        }
    });

    $shopRegistrationPassword.keypress(function (e) {
        if (e.which == 13) {
            submitValidation();
        }
    });

    $shopRegistrationName.keypress(function () {
        $shopRegistrationName.val(healShopName($(this).val(), false));
    }).keyup(function () {
        $shopRegistrationName.val(healShopName($(this).val(), false));
    }).focusout(function () {
        if ($shopRegistrationName.val() === '') {
            $errorRegistrationName.removeClass('notvalidfrontpage');
        } else {
            validShopName();
        }
    });


    function submitValidationInfo(validationInput,errorText){
        validationInput.addClass('notvalidfrontpage');
        validationInput.parent().addClass('has-error');
        validationInput.html(errorText);
    }

    function submitValidation() {

        var reg = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (reg.test(form.email.value) == false) {
            submitValidationInfo($errorRegistrationEmail,'Kérjük adjon meg egy érvényes e-mail címet.');
        }
        else if (/^[\s]*$/.test(form.password.value)) {
            submitValidationInfo($errorRegistrationPassword,'Nem adott meg Jelszót.');
        }
        else if (form.password.value.length < 5) {
            submitValidationInfo($errorRegistrationPassword,'A Jelszónak minimum 5 karakterből kell állnia.');
        }
        else if (/^[\s]*$/.test(form.web.value)) {
            submitValidationInfo($errorRegistrationName,'Nem adott meg Boltnevet.');
        }
        else if (form.web.value.length < 4) {
            submitValidationInfo($errorRegistrationName,'A Webcímnek minimum 4 karakterből kell állnia.');
        }
        else if (form.web.value.length > 64) {
            submitValidationInfo($errorRegistrationName,'A Webcím maximum 64 karakterből állhat.');
        }

        else {
            if (validEmail() && validShopName()) {
                submitRegistrationForm();
            }
        }
    }

    function validEmail(){
        var result = false;
        $.ajax({
            async: false,
            url: LIVE_SITE + "/ajax/validateUserEmail.php",
            method: 'POST',
            data: {
                email: $shopRegistrationEmail.val()
            }
        }).done(function(data){
            if (data == 1) {
                result = false;
                $errorRegistrationEmail.addClass('notvalidfrontpage');
                $errorRegistrationEmail.parent().addClass('has-error');
                submitValidationInfo($errorRegistrationEmail,'Ezzel az e-mail címmel már regisztráltak.');


            } else {
                result = true;
                $errorRegistrationEmail.removeClass('notvalidfrontpage');
                $errorRegistrationEmail.parent().removeClass('has-error');
            }
        });
        return result;
    }

    function validShopName(){
        var result = false;
        $.ajax({
            async: false,
            url: LIVE_SITE + "/ajax/validateWebcim.php",
            method: 'POST',
            data: {
                webcim: healShopName($shopRegistrationName.val(), true)
            }
        }).done(function(data){
            if (data == 1) {
                result = false;
                $errorRegistrationName.addClass('notvalidfrontpage');
                $errorRegistrationName.parent().addClass('has-error');
            } else {
                result = true;
                $errorRegistrationName.removeClass('notvalidfrontpage');
                $errorRegistrationName.parent().removeClass('has-error');
            }
        });
        return result;
    }

    function submitRegistrationForm() {
        form.submit();
    }

}
